var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97075 3.80482C9.2311 3.54447 9.2311 3.12236 8.97075 2.86201C8.7104 2.60166 8.28829 2.60166 8.02794 2.86201L3.36128 7.52868C3.10093 7.78903 3.10093 8.21114 3.36128 8.47149L8.02794 13.1382C8.28829 13.3985 8.7104 13.3985 8.97075 13.1382C9.2311 12.8778 9.2311 12.4557 8.97075 12.1953L5.44216 8.66675L13.166 8.66675C13.5342 8.66675 13.8327 8.36827 13.8327 8.00008C13.8327 7.63189 13.5342 7.33342 13.166 7.33342L5.44216 7.33341L8.97075 3.80482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.f16005048645b816d33c5aa388e2539c.svg";
export { ForwardRef as ReactComponent };